<template>
  <b-container fluid>
    <backlink />
    <h1>Paramètres boutique</h1>

    <AdminForm
      :config="config"
      :form="form"
      :isBusy="isBusy"
      :options="options"
      :submit="submit"
    ></AdminForm>
  </b-container>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

/**
 * Coordonnées et destinataires de la boutique.
 *
 * AC-002 — La sélection « Produits à la Une » (réglage `home_new_products`) est éditée sur
 * son propre écran (components/FeaturedProduct) et n'est volontairement plus touchée ici :
 * cet écran la réécrirait avec la valeur qu'il a lue à son ouverture, écrasant en silence
 * une sélection modifiée entre-temps.
 */
export default {
  name: "AxilocSettingForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {},
      isBusy: false,
      ids: {},
      // Choix des réglages de type liste. Valeurs en chaînes : le réglage est stocké en texte,
      // un booléen `false` y deviendrait une chaîne vide.
      options: {
        location_for_account_enabled_options: [
          { value: "1", text: "Activée" },
          { value: "0", text: "Désactivée" },
        ],
        long_term_enabled_options: [
          { value: "1", text: "Activée" },
          { value: "0", text: "Désactivée" },
        ],
      },
    };
  },
  mounted() {
    this.isBusy = true;
    this.$store
      .dispatch(config.storeNamespace + "/getAll", {
        wait: true,
      })
      .then(() => {
        const ids = {};
        const form = {};
        // Les champs sont lus depuis la config : un réglage ajouté là est repris ici sans
        // retouche, et un réglage absent de la base (migration pas encore jouée) laisse le
        // formulaire s'ouvrir au lieu de casser sur un `undefined`.
        config.fields.forEach((field) => {
          const item =
            this.$store.getters[config.storeNamespace + "/getSetting"](field.name);
          ids[field.name] = item ? item.id : null;
          form[field.name] = item ? item.value : null;
        });
        this.ids = ids;
        this.form = form;
        this.isBusy = false;
      });
  },
  methods: {
    submit() {
      for (const setting in this.form) {
        // Une valeur vidée est enregistrée telle quelle : c'est ainsi qu'on retire un lien
        // optionnel du footer. Seul un réglage absent de la base est ignoré.
        if (this.ids[setting] === null || this.ids[setting] === undefined) {
          continue;
        }
        this.$store.dispatch(this.config.storeNamespace + "/saveItem", {
          id: this.ids[setting],
          setting: setting,
          value: this.form[setting] === null ? "" : this.form[setting],
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AxilocSetting/AxilocSettingForm.vue